import React from 'react'
import { Route, IndexRoute } from 'react-router'

import Container from './Container'
import CustomSupporterPage from './CustomSupporterPage'
import CustomTeamPage from './CustomTeamPage'
import Home from './Home'
import Login from './Login'
import Page from './Page'
import Preview from './Preview'
import StravaConnect from './StravaConnect'

export default (
  <Route path='/' component={Container}>
    <IndexRoute component={Home} />
    <Route path='preview' component={Preview} />
    <Route path='fundraising/:slug/connect' component={StravaConnect} />
    <Route path='fundraising/:slug' component={CustomSupporterPage}>
      <Route path='login' component={Login} />
    </Route>
    <Route path='teams/:slug' component={CustomTeamPage} />
    <Route path=':slug' component={Page} />
  </Route>
)
